import React , { useState } from 'react';
import PopUpDialogTemplate from './PopUpDialogTemplate';



const TournamentUnregisterSuccessfullDialog = ({ onClose, onConfirm, t}) => {

  const BTN_NAMES = {
    confirm: t('ok'),
  }
  return (
    <React.Fragment>
      <div className="tournaments__popup tournament__dialog__unregister">
        <div className="tournaments__popup__overlay tournaments__unregister__successfull__overlay" onClick={onClose} />
        <PopUpDialogTemplate
          title= {t('tournamentUnregistration')}
          iconName={'successfull'}
          text={t('youHaveSuccessfullyUnregistered')}
          onConfirm={onConfirm}
          btnNames={BTN_NAMES}
        >
        </PopUpDialogTemplate>
      </div>
    </React.Fragment>
  )
}

export default TournamentUnregisterSuccessfullDialog;